'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Changed variant ID
   *******************************/
  const defaultVariantsWrap = document.querySelector('.default-variants');
  if (defaultVariantsWrap) {
    const productInfo = document.querySelector('#product-info');

    if (!productInfo) {
      return false
    }

    const radioButton = productInfo.querySelectorAll('.radio__buttons input');

    if (radioButton.length) {
      const inputForm = productInfo.querySelector('input.variant-id')
      radioButton.forEach(input => {
        input.addEventListener('change', ({target}) => {
          inputForm.value = target.dataset.id
        });
      });
    }
  }

});